import { Reducer, combineReducers } from 'redux';
// import { UsersState, UsersReducer } from './_model/user/user.reducer';
// export * from './_model/user/user.reducer';
import { WatchHistoryState, WatchHistoryReducer } from './_model/watch-history/watch-history.reducer';
export * from './_model/watch-history/watch-history.reducer';
import { CommentsState, CommentsReducer } from './_model/comment/comments.reducer';
export * from './_model/comment/comments.reducer';

import { RefReplyState, RefReplyReducer } from './_model/reply/reply.reducer';
export * from './_model/reply/reply.reducer';

import { ConfigState, ConfigReducer } from './_model/config/config.reducer';
export * from './_model/comment/comments.reducer';

import { VideoState, VideoReducer } from './_model/video/video.reducer';
export * from './_model/video/video.reducer';

export interface AppState {
   // users: UsersState;
    watchHistory: WatchHistoryState;
    comments: CommentsState;
    config: ConfigState;
    refReply: RefReplyState;
    video: VideoState;
}

const rootReducer: Reducer<AppState> = combineReducers<AppState> ({
   // users: UsersReducer,
    watchHistory: WatchHistoryReducer,
    comments: CommentsReducer,
    config: ConfigReducer,
    refReply: RefReplyReducer,
    video: VideoReducer,
});

export default rootReducer;
